import React, { useCallback, useRef } from 'react'
import { Grid } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { dataCatalog } from '../../../../api/coreData'
import EmptySection from '../../../atoms/EmptySection'
import Loading from '../../../molecules/Loading'
import SummitOnlyContent from '../../../atoms/SummitOnlyContent'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import MapPipelineDialog from './dialogs/MapPipelineDialog'
import DatasourceLayout from './shared/DatasourceLayout'

const SEARCH_VALUE = {
  filters: {
    type: 'api'
  },
  includes: {
    namespace: true
  }
}

function CatalogPipelines () {
  const { data, isLoading } = dataCatalog.useSearchCatalogDataSources(SEARCH_VALUE)
  const mapPipelineRef = useRef(null)
  const onMapPipeline = useCallback(() => {
    mapPipelineRef.current.open()
  }, [])

  if (isLoading) {
    return (
      <FadeIn key='loading'>
        <Loading />
      </FadeIn>
    )
  }

  if (!(data?.total || 0)) {
    return (
      <FadeIn key='no_data'>
        <EmptySection title='No Pipelines' description='' />
        <SummitOnlyContent>
          <FlexRow className='justify-center'>
            <SydButton
              variant='primary'
              size='md'
              icon='warning'
              onClick={onMapPipeline}
            >
              Map a Pipeline
            </SydButton>
          </FlexRow>
          <MapPipelineDialog ref={mapPipelineRef} />
        </SummitOnlyContent>
      </FadeIn>
    )
  }

  return (
    <FadeIn key='pipelines'>
      <Grid container spacing={2}>
        <SummitOnlyContent>
          <Grid item xs={12}>
            <FlexRow className='justify-end'>
              <SydButton
                variant='primary'
                size='md'
                icon='warning'
                onClick={onMapPipeline}
              >
                Map a Pipeline
              </SydButton>
              <MapPipelineDialog ref={mapPipelineRef} />
            </FlexRow>
          </Grid>
        </SummitOnlyContent>
        <Grid item xs={12}>
          <DatasourceLayout items={data?.data || []} />
        </Grid>
      </Grid>
    </FadeIn>
  )
}

export default CatalogPipelines
